'use strict';exports.__esModule = true;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactModal = require('react-modal');var _reactModal2 = _interopRequireDefault(_reactModal);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _ = require('../');
var _Realtor = require('./Realtor.scss');var styles = _interopRequireWildcard(_Realtor);
var _googleService = require('../../helpers/googleService');var _googleService2 = _interopRequireDefault(_googleService);
var _formatCityName = require('../../helpers/formatCityName');var _formatCityName2 = _interopRequireDefault(_formatCityName);
var _constants = require('../../constants');
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var DEFAULT_DISPLAYED_PINS = 'forSale';

var modalStyle = {
  overlay: { backgroundColor: 'rgba(0, 0, 0, 0.75)' },
  content: {
    top: 'initial',
    left: 0,
    right: 0,
    bottom: '18px',
    padding: 0,
    background: 'transparent',
    border: 0 } };



var getLocalizedField = function getLocalizedField(data, field, locale) {
  if (!data || !data[field]) {
    return '';
  }

  if (!data[field][locale] && !data[field][_constants.language.fallback]) {
    return '';
  }

  return data[field][locale] || data[field][_constants.language.fallback];
};

var getLocalizeRealtorData = function getLocalizeRealtorData(data, locale) {return Object.assign({},
  data, {
    name: getLocalizedField(data, 'name', locale),
    title: getLocalizedField(data, 'title', locale),
    description: getLocalizedField(data, 'description', locale) });};var


Realtor = function (_Component) {_inherits(Realtor, _Component);function Realtor() {var _temp, _this, _ret;_classCallCheck(this, Realtor);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      displayPinsFor: DEFAULT_DISPLAYED_PINS }, _this.























    getPropertiesFor = function (optionType) {
      if (!_this.props.properties) {
        return null;
      }

      return _this.props.properties && _this.props.properties.filter(function (prop) {return prop.option_type === optionType;});
    }, _this.

    scrollEventListener = function () {var _document$body =
      document.body,scrollTop = _document$body.scrollTop,offsetHeight = _document$body.offsetHeight;
      if (_this.actionButtonAnchor.offsetTop <= scrollTop + offsetHeight) {
        _this.actionButton.style.position = 'static';
      } else {
        _this.actionButton.style.position = '';
      }
    }, _this.

    initializeMap = function () {
      _this.map = new global.window.google.maps.Map(_this.mapContainer, Object.assign({},
      _this.googleService.getMapOptions(), {
        gestureHandling: 'cooperative',
        zoomControl: false,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        zoom: 15,
        fullscreenControl: false }));

      _this.renderMapPins();
    }, _this.

    clearPins = function () {
      if (!_this.pins || !_this.pins.length) return null;
      return _this.pins.forEach(function (pin) {return pin.setMap(null);});
    }, _this.

    formSubmitHandler = function (values) {
      _this.props.sendRealtorContactUsForm(Object.assign({},
      values, {
        realtor_id: _this.props.realtorId,
        user_id: _this.props.userId }));

    }, _this.

    propertyCellClickHandler = function (preloadData) {
      setTimeout(function () {return _this.props.openDetailsPopup(Object.assign({},
        preloadData, {
          optionType: _this.state.displayPinsFor === 'forSale' ? 'buy' : 'rent' }));});

    }, _this.

    renderCell = function (property) {
      var locale = _this.props.locale;
      var englishAddressRequired = _constants.localesWithEnglishAddress.includes(locale);
      var address = englishAddressRequired ?
      property.address.en :
      property.address[locale] || property.address[_constants.language.default];

      var houseNumber = address.house_number ? ' ' + address.house_number + ',' : '';
      var stringAddress = address.street_name + ' ' + houseNumber;var


      id =






      property.id,thumbnail = property.thumbnail,price = property.price,_property$additional_ = property.additional_info;_property$additional_ = _property$additional_ === undefined ? {} : _property$additional_;var rooms = _property$additional_.rooms,bathrooms = _property$additional_.bathrooms,parking = _property$additional_.parking,areaObject = _property$additional_.area;
      var area = (typeof areaObject === 'undefined' ? 'undefined' : _typeof(areaObject)) === 'object' ? areaObject.base : areaObject; // for migration purposes
      var floor = property && property.additional_info && property.additional_info.floor &&
      property.additional_info.floor.on_the;
      var propertyImage = thumbnail;

      return (
        _react2.default.createElement(_.PropertyCell, {
          id: id,
          locale: _this.props.locale,
          price: price,
          address: stringAddress,
          key: property.id,
          translate: _this.props.translate,
          addressData: address,
          rooms: rooms,
          area: area,
          floor: floor,
          parkingSpots: parking,
          bathrooms: bathrooms,
          photo: propertyImage,
          parkingIconTitle: _this.props.translate('iconTitles', 'parkingIcon'),
          roomsIconTitle: _this.props.translate('iconTitles', 'roomsIcon'),
          squareIconTitle: _this.props.translate('iconTitles', 'squareIcon'),
          floorIconTitle: _this.props.translate('iconTitles', 'floorIcon'),
          groundFloorTitle: _this.props.translate('propertyDetails', 'details', 'groundFloorShortcut'),
          propertyType: _this.props.translate('propertyTypes', property.property_type)(),
          openDetailsPopup: _this.propertyCellClickHandler,
          isRtl: _this.props.isRtl,
          isMobile: _this.props.isMobile,
          city: address.city_name,
          cityEn: (0, _formatCityName2.default)(property.address.en.city_name),
          hideFavoriteButton: true }));


    }, _this.

    renderProperties = function (properties) {
      if (!properties) {
        return _react2.default.createElement('span', null, 'Loading');
      }

      if (!properties.length) {
        return _react2.default.createElement('span', null, 'No result');
      }

      return properties.map(_this.renderCell);
    }, _this.











    renderMapPinLink = function (type) {return (
        _this.state.displayPinsFor === type ?
        _react2.default.createElement('a', { onClick: function onClick(evt) {evt.preventDefault();} }, _this.props.translate('realtorPage', type)) :

        _react2.default.createElement('span', { onClick: function onClick() {return _this.setState({ displayPinsFor: type });} },
          _this.props.translate('realtorPage', type)));}, _this.




    renderMapPins = function () {
      _this.clearPins();

      var optionType = {
        forSale: 'buy',
        forRent: 'rent' }[
      _this.state.displayPinsFor];
      var properties = _this.getPropertiesFor(optionType);

      if (!properties || !properties.length || !_this.map) return null;

      _this.pins = properties.map(function (property) {return _this.googleService.createPin(
        property.address.location.lat,
        property.address.location.lon,
        property);});

      _this.pins.forEach(function (pin) {pin.setMap(_this.map);});
      var bounds = new window.google.maps.LatLngBounds();
      for (var i = 0; i < _this.pins.length; i += 1) {
        bounds.extend(_this.pins[i].getPosition());
      }

      return _this.map.fitBounds(bounds);
    }, _this.

    renderContactUsForm = function () {return (
        _react2.default.createElement(_.RealtorContactUs, {
          translate: _this.props.translate,
          isMobile: _this.props.isMobile,
          onSubmit: _this.formSubmitHandler,
          closeModal: _this.props.closeRealtorContactUsForm,
          isRtl: _this.props.isRtl,
          formSubmitting: _this.props.formSubmitting,
          formSubmitted: _this.props.formSubmitted,
          showMessage: _this.props.openMessageModal,
          formError: _this.props.formError }));}, _temp), _possibleConstructorReturn(_this, _ret);}Realtor.prototype.componentDidMount = function componentDidMount() {var _this2 = this;new _googleService2.default(this.props.locale, function (gs) {// eslint-disable-line no-new
      _this2.googleService = gs;_this2.initializeMap();});if (global && global.window && this.props.isMobile) {window.addEventListener('scroll', this.scrollEventListener);}};Realtor.prototype.componentDidUpdate = function componentDidUpdate() {this.renderMapPins();};Realtor.prototype.componentWillUnmount = function componentWillUnmount() {if (this.props.isMobile) {window.removeEventListener('scroll', this.scrollEventListener);}}; // renderMapPinLink = type => (
  //   this.state.displayPinsFor === type
  //     ? <span>{this.props.translate('realtorPage', type)}</span>
  //     : (
  //       <a onClick={(evt) => { evt.preventDefault(); this.setState({ displayPinsFor: type }); }}>
  //         {this.props.translate('realtorPage', type)}
  //       </a>
  //     )
  // );
  Realtor.prototype.render = function render() {var _this3 = this;var _props = this.props,realtor = _props.realtor,locale = _props.locale,route = _props.route;var localizeRealtorData = getLocalizeRealtorData(realtor, locale);var propertiesForBuy = this.getPropertiesFor('buy');var propertiesForRent = this.getPropertiesFor('rent');var SEOTitle = localizeRealtorData.title || 'Realtor ' + (localizeRealtorData.name || 'page');var metaTitle = SEOTitle + ' | \u202BOnMap';
    var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);

    return (
      _react2.default.createElement('section', { className: styles.realtor },
        _react2.default.createElement(_reactHelmet2.default, { titleTemplate: this.props.translate('title', 'titleTemplate').toString() },
          _react2.default.createElement('title', null, SEOTitle),
          _react2.default.createElement('meta', { property: 'title', content: metaTitle }),
          _react2.default.createElement('meta', { property: 'og:title', content: metaTitle }),
          _react2.default.createElement('meta', { property: 'og:url', content: '' + _constants.shareUrl + route }),
          _react2.default.createElement('meta', { name: 'description', content: localizeRealtorData.description }),
          _react2.default.createElement('meta', { property: 'og:description', content: localizeRealtorData.description }),
          _react2.default.createElement('link', { rel: 'canonical', href: '' + _constants.shareUrl + route }),
          multiLanguage && multiLanguage.map(function (item) {return (
              _react2.default.createElement('link', { key: item.hrefLang + '-key', rel: item.rel, hrefLang: item.hrefLang, href: item.href }));})),


        _react2.default.createElement('div', { className: 'realtor-info' },
          _react2.default.createElement(_.AboutRealtor, {
            translate: this.props.translate('realtorPage'),
            name: localizeRealtorData.name,
            title: localizeRealtorData.title,
            description: localizeRealtorData.description,
            phoneNumber: localizeRealtorData.phone_number,
            companyName: localizeRealtorData.company_name,
            licenseNumber: localizeRealtorData.license_number,
            licenseFrom: localizeRealtorData.licensed_since,
            profileImage: localizeRealtorData.profile_img,
            isMobile: this.props.isMobile }),


          !this.props.isMobile &&
          _react2.default.createElement('aside', null,
            this.renderContactUsForm())),




        _react2.default.createElement('div', { className: 'realtor-properties-wrapper' },
          _react2.default.createElement('div', { className: 'realtor-properties' },
            !!propertiesForBuy && !!propertiesForBuy.length &&
            _react2.default.createElement('div', null,
              _react2.default.createElement('h3', null,
                this.props.translate('realtorPage', 'propertiesForSale'), '\xA0 (',

                propertiesForBuy.length, ' ', this.props.translate('realtorPage', 'property'), ')'),


              _react2.default.createElement('div', { className: 'properties-list' },
                this.renderProperties(propertiesForBuy))),




            _react2.default.createElement('hr', null),

            !!propertiesForRent && !!propertiesForRent.length &&
            _react2.default.createElement('div', null,
              _react2.default.createElement('h3', null,
                this.props.translate('realtorPage', 'propertiesForRent'), '\xA0 (',

                propertiesForRent.length, ' ', this.props.translate('realtorPage', 'property'), ')'),


              _react2.default.createElement('div', { className: 'properties-list' },
                this.renderProperties(propertiesForRent))),




            _react2.default.createElement('hr', null),

            _react2.default.createElement('div', { className: 'realtor-properties-map' },
              _react2.default.createElement('h3', null, this.props.translate('realtorPage', 'propertiesMap')),

              _react2.default.createElement('div', null,
                this.renderMapPinLink('forSale'), ' | ', this.renderMapPinLink('forRent')),


              _react2.default.createElement('div', {
                className: 'map-container',
                style: { width: this.props.isMobile ? '100vw' : '700px', height: '400px' },
                ref: function ref(_ref) {_this3.mapContainer = _ref;} })))),





        this.props.isMobile &&
        _react2.default.createElement('div', { className: 'mobile-action-button-container' },
          _react2.default.createElement('button', { ref: function ref(_ref2) {_this3.actionButton = _ref2;}, onClick: this.props.openRealtorContactUsForm },
            this.props.translate('realtorPage', 'contactsForm', 'title'))),




        this.props.isMobile && _react2.default.createElement('div', { ref: function ref(_ref3) {_this3.actionButtonAnchor = _ref3;} }),

        this.props.isMobile &&
        _react2.default.createElement(_reactModal2.default, {
            isOpen: this.props.mobileContactUsIsOpen,
            contentLabel: 'PropertyDetailsPrintPage',
            portalClassName: 'mobile-realtor-contact-us-form' + (this.props.isRtl ? ' rtl' : ''),
            style: modalStyle,
            onRequestClose: this.props.closeRealtorContactUsForm,
            shouldCloseOnOverlayClick: true },

          this.renderContactUsForm())));




  };return Realtor;}(_react.Component);exports.default = Realtor;


Realtor.propTypes = {
  realtorId: _propTypes2.default.string,
  userId: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  location: _propTypes2.default.object, //eslint-disable-line
  realtor: _propTypes2.default.object,
  properties: _propTypes2.default.array,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  mobileContactUsIsOpen: _propTypes2.default.bool,
  openRealtorContactUsForm: _propTypes2.default.func,
  closeRealtorContactUsForm: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  sendRealtorContactUsForm: _propTypes2.default.func,
  formSubmitting: _propTypes2.default.bool,
  formSubmitted: _propTypes2.default.bool,
  openMessageModal: _propTypes2.default.func,
  formError: _propTypes2.default.object,
  route: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Realtor/Realtor.js
// module id = 2823
// module chunks = 0